"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@teamsnap/teamsnap-ui/src/css/teamsnap-ui.scss");
require("babel-polyfill");
require("core-js/es/map");
require("core-js/es/set");
const react_redux_1 = require("react-redux");
require("promise-polyfill/src/polyfill");
const React = __importStar(require("react"));
require("react-datepicker/dist/react-datepicker.css");
const browser_rum_1 = require("@datadog/browser-rum");
const Sentry = __importStar(require("@sentry/react"));
const api_1 = require("core/api");
const constants_1 = require("core/constants");
const ReactDOM = __importStar(require("react-dom"));
const react_modal_1 = __importDefault(require("react-modal"));
const ampli_1 = require("src/ampli");
const store_1 = __importDefault(require("state/store"));
const amplitude_experiments_1 = require("./amplitude_experiments");
const help_scout_1 = require("./help-scout");
const maintenance_1 = __importDefault(require("./maintenance"));
const root_1 = __importDefault(require("./root"));
api_1.OpenAPI.BASE = constants_1.API_URL;
api_1.OpenAPI.WITH_CREDENTIALS = true;
browser_rum_1.datadogRum.init({
    applicationId: 'edda1937-1789-4860-b0dd-7c80e77ed87a',
    clientToken: 'pub68603c6c70838871c4e1694337f36890',
    env: 'production',
    sampleRate: 10,
    silentMultipleInit: true,
    site: 'datadoghq.com',
    trackInteractions: false,
});
const attribution = {
    initialEmptyValue: '',
    excludeReferrers: [/teamsnap\.com$/, /stripe\.com$/],
};
const defaultTracking = {
    attribution,
    fileDownloads: false,
    formInteractions: false,
    pageViews: false,
    sessions: false,
};
ampli_1.ampli.load({
    disabled: window.Cypress ? true : false,
    environment: constants_1.AMPLITUDE_ENVIRONMENT,
    client: { configuration: { defaultTracking } },
});
const store = (0, store_1.default)();
const app = constants_1.isUnderMaintenance ? (React.createElement(maintenance_1.default, null)) : (React.createElement(react_redux_1.Provider, { store: store },
    React.createElement(Sentry.ErrorBoundary, { beforeCapture: (scope, _e) => {
            scope.setTag('error_boundary', 'app');
        } },
        React.createElement(root_1.default, null))));
(0, amplitude_experiments_1.initAmplitudeExperiments)();
window.onload = () => {
    if (window.location.host?.includes('teamsnap.com')) {
        Sentry.init({
            dsn: 'https://a0ada6e50a324674846b9a323d08b990@sentry.io/1394420',
            environment: constants_1.ENV,
            release: `accounts-frontend@${process.env.REACT_APP_RELEASE || 'dev'}`,
        });
    }
    if (!window.location.pathname.includes('/plan')) {
        (0, help_scout_1.initHelpScout)();
    }
};
react_modal_1.default.setAppElement('#content');
ReactDOM.render(app, document.getElementById('content'));
